import { FunctionComponent } from 'react';

import TableContainer from '@material-ui/core/TableContainer';
import styled from 'styled-components';

const StyledTableContainer = styled(TableContainer)<{component: FunctionComponent}>`
    margin-top: 20px;
`;

export default StyledTableContainer;
